module.exports = __webpack_public_path__ + "img/1938_Gleichschaltung.71f76a51.jpg";